import { CustomWrapper } from "./textArea.style";
import { TextAreaProps } from "./textArea.type";

export const TextArea = ({ content, ...restProps }: TextAreaProps) => {
    const formattedText = content?.replace(/<br>/g, "\n");

    return <CustomWrapper value={formattedText} readOnly={true} {...restProps}></CustomWrapper>;
};
